import React from "react";
import Header from "Components/PucForm/UserHeader/Header";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";

import UserBody from "./Userbody";
import PUC_Header from "Components/Shared/PUC_Header";
import { useLocation } from "react-router-dom";
// import { useUserContext } from "Hooks/UserContext";

const AppUserLayout = () => {
  // const { setLoggedIn, setRole } = useUserContext();
  const location = useLocation();

  // useEffect(() => {
  //   if (localStorage.getItem("role") != undefined) {
  //     setRole(localStorage.getItem("role"));
  //   }
  //   if (localStorage.getItem("LoggedIn") === "true") {
  //     setLoggedIn(true);
  //   }
  // }, []);
  const formTypes=["/wonder-world", "/keysoul-store", "/display-wall"]
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        {formTypes.some(path => location.pathname.includes(path)) ? <PUC_Header /> : <Header />}
        <Box
          className="text"
          px={formTypes.some(path => location.pathname.includes(path))? 8 : 0}
          py={formTypes.some(path => location.pathname.includes(path)) ? 8 : 8}
          sx={{
            width: "100%",
            overflow: "hidden"
          }}>
          <UserBody />
        </Box>
      </Box>
    </>
  );
};
export default React.memo(AppUserLayout);
